import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cake } from "lucide-react";

export function BirthdayPledgeBand() {
  return (
    <section className="container mx-auto px-4 py-16">
      <div className="mx-auto flex max-w-5xl flex-col items-start gap-6 rounded-3xl border border-border bg-muted/40 p-8 shadow-card md:flex-row md:items-center md:justify-between md:p-10">
        <div className="flex items-start gap-4 md:items-center">
          <div className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Cake className="h-6 w-6" aria-hidden />
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary">
              Make it count
            </span>
            <h2 className="mt-1 font-display text-2xl font-semibold md:text-3xl">
              Skip the gifts. Pledge your birthday for Sri Lanka.
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
              Friends donate instead of gifting. About 30 days before your birthday we draft a fundraiser
              for your approval, then send you a kit to share.
            </p>
          </div>
        </div>
        <Button asChild size="lg" className="rounded-full md:shrink-0">
          <Link to="/birthday">Pledge your birthday</Link>
        </Button>
      </div>
    </section>
  );
}
